export const Subscriptions = () => import('./Subscriptions').then(({ Subscriptions }) => {
  return {
    Component: Subscriptions
  };
});
